// Nightlevel's approved article-to-product funnel, using Shopify consent and the existing Clarity project.
(function () {
  if (window.nightlevelFunnelBound) return;
  var article = document.querySelector('[data-nightlevel-listicle]');
  var product = document.querySelector('[data-sb-nightlevel-pdp-v1]');
  if (!article && !product) return;
  window.nightlevelFunnelBound = true;
  var query = new URLSearchParams(window.location.search);
  var token = query.get('sb');
  if (!/^[0123456789abcdefghjkmnpqrstvwxyz]{10}$/.test(token || '')) token = null;
  var loaded = false;
  var viewed = false;

  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed();
  }
  function event(name) {
    if (loaded && allowed()) window.clarity('event', name);
  }
  function syncConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || typeof privacy.marketingAllowed !== 'function') return;
    if (!loaded && allowed()) {
      loaded = true;
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      if (!document.querySelector('script[src*="clarity.ms/tag/xuqgawwu9c"]')) {
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.clarity.ms/tag/xuqgawwu9c';
        document.head.appendChild(script);
      }
    }
    if (!loaded) return;
    window.clarity('consentv2', {
      ad_Storage: privacy.marketingAllowed() ? 'granted' : 'denied',
      analytics_Storage: allowed() ? 'granted' : 'denied'
    });
    if (!allowed() || viewed) return;
    viewed = true;
    window.clarity('set', 'product', 'Nightlevel');
    window.clarity('set', 'funnel_version', 'neck-back-20260912');
    window.clarity('set', 'page_kind', article ? 'listicle' : 'pdp');
    if (token) window.clarity('set', 'sb_token', token);
    event(article ? 'nl_listicle_view' : 'nl_pdp_view');
    if (product && query.get('nl_from') === 'listicle') event('nl_pdp_from_listicle');
  }

  if (article) {
    article.querySelectorAll('[data-nightlevel-pdp-link]').forEach(function (link) {
      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== '/products/nightlevel-cloud-support-pillow') return;
      if (token) url.searchParams.set('sb', token);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
        var value = query.get(key);
        if (value) url.searchParams.set(key, value);
      });
      url.searchParams.set('nl_from', 'listicle');
      link.href = url.toString();
      link.addEventListener('click', function () { event('nl_listicle_cta'); });
    });
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify && window.Shopify.customerPrivacy) syncConsent();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) syncConsent();
    });
  }
})();
